import { render, staticRenderFns } from "./FedExInvoiceForm.vue?vue&type=template&id=7dd05572"
import script from "./FedExInvoiceForm.vue?vue&type=script&lang=js"
export * from "./FedExInvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports